import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'

// interface DataItem {
//   color: string
//   title: string
// }

// interface TitleProps {
//   highlighted: number | null
//   data: DataItem[]
// }

// function Title({ highlighted, data }: TitleProps) {
function Title({ highlighted, data, fallbackTitle }) {
  const theme = useTheme()

  const isValidHighlight =
    highlighted !== undefined &&
    highlighted !== null &&
    data[highlighted] !== undefined

  const backgroundColor = isValidHighlight
    ? data[highlighted].color
    : 'transparent'

  const textColor = isValidHighlight
    ? theme.palette.background.default
    : '#373B47'

  const titleText =
    typeof highlighted === 'number' && data[highlighted]
      ? data[highlighted].title
      : fallbackTitle ?? ''

  const isFallback = !(typeof highlighted === 'number' && data[highlighted])

  return (
    <Typography
      // variant={'body3'}
      sx={{
        mt: 0,
        borderRadius: 10,
        minWidth: '80px',
        justifySelf: 'center',
        textAlign: 'center',
        paddingX: 2,
        paddingY: 1,
        fontWeight: 700,
        fontSize: isFallback ? 18 : 14,
        // color: textColor,
        color: isFallback ? '#495057' : '#f9f9f9',
        backgroundColor: backgroundColor,
      }}
    >
      {titleText}
    </Typography>
  )
}

export default Title
